import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "provider", "syncMode", "section" ]

  connect() {
    this.update()
  }

  update() {
    this.syncSyncModeOptions()
    this.sectionTargets.forEach((section) => {
      const visible = this.sectionMatches(section)
      section.hidden = !visible
      this.toggleSectionInputs(section, visible)
    })
  }

  syncSyncModeOptions() {
    const supportedModes = this.supportedSyncModes()

    Array.from(this.syncModeTarget.options).forEach((option) => {
      const enabled = supportedModes.includes(option.value)
      option.disabled = !enabled
      option.hidden = !enabled
    })

    if (!supportedModes.includes(this.syncModeTarget.value)) {
      this.syncModeTarget.value = supportedModes[0]
      this.syncModeTarget.dispatchEvent(new Event("input"))
    }
  }

  sectionMatches(section) {
    const providers = this.valuesFrom(section.dataset.providers)
    const syncModes = this.valuesFrom(section.dataset.syncModes)

    return this.includesOrEmpty(providers, this.providerTarget.value) &&
      this.includesOrEmpty(syncModes, this.syncModeTarget.value)
  }

  supportedSyncModes() {
    switch (this.providerTarget.value) {
      case "gmail":
      case "outlook":
        return [ "oauth", "manual" ]
      case "generic":
      case "ses_inbound":
      default:
        return [ "webhook", "manual" ]
    }
  }

  valuesFrom(value) {
    return (value || "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean)
  }

  includesOrEmpty(values, currentValue) {
    return values.length === 0 || values.includes(currentValue)
  }

  toggleSectionInputs(section, visible) {
    section.querySelectorAll("input, select, textarea, button").forEach((element) => {
      if (element === this.providerTarget || element === this.syncModeTarget) return

      if (visible) {
        if (element.dataset.mailboxConnectionFormHiddenDisabled === "true") {
          element.disabled = false
          delete element.dataset.mailboxConnectionFormHiddenDisabled
        }
      } else if (!element.disabled) {
        element.disabled = true
        element.dataset.mailboxConnectionFormHiddenDisabled = "true"
      }
    })
  }
}
